import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Row,
  Input,
  Select,
  Space,
  Typography,
  InputNumber,
  AutoComplete,
} from "antd";
import { SUCCESS_CODE, ERR_0022 } from "../../../../lib/const";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  DATA_MASTER_DATA_TYPE,
  ESTATE_TYPE,
  WORK_PERIOD,
} from "../../../../lib/const";
// import useLineOfWork from "../../../../lib/hooks/useLineOfWork";
import useListLineOfWork from "../../../../lib/hooks/useListLineOfWork";
import useMasterData from "../../../../lib/hooks/useMasterData";
import useEState from "../../../../lib/hooks/useEState";

import { routes } from "../../../../routes";
import moment from "moment";

import {
  SearchVisitContext,
  initialPageValues,
  initialSearchValues,
} from "../searchContext";
import { getListVisitYear } from "../../../../services/customerVisit";

const { Title } = Typography;
const { Option } = Select;

const Search = ({ roleUser }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  // const [lineOfWorkList] = useLineOfWork();
  const [lineOfWorks, lineOfWorkList] = useListLineOfWork();
  const [estateType] = useMasterData(DATA_MASTER_DATA_TYPE, ESTATE_TYPE);
  const [estates, estateList] = useEState();
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);

  const {
    setPageValues,
    setSearch,
    searchValues,
    pageValues,
    setSearchValues,
  } = useContext(SearchVisitContext);
  // const [searchCollapse, setSearchCollapse] = useState(false);
  const [estateId, setEstateId] = useState("");
  // const [dataId, setDataId] = useState("");
  // const [lineOfWork, setLineOfWork] = useState("");
  const [listYear, setLisYear] = useState([]);

  const handleClearSearchForm = () => {
    form.resetFields();
    setSearchValues(initialSearchValues);
    setPageValues(initialPageValues);
    setSearch(true);
  };

  const onSearch = (values) => {
    setSearch(true);
    setSearchValues({
      yearOfBudget: values?.yearOfBudget || "",
      lineOfWork: values?.lineOfWork || "",
      estateId: estateId || "",
    });
  };

  useEffect(() => {}, [form]);

  const onSelectEstateId = (value, option) => {
    setEstateId(option.estateId);
  };

  const onChangeEstateId = (value) => {
    if (value === "") {
      setEstateId("");
    }
  };

  // const onSelectLineOfWork = (value, option) => {
  //   setLineOfWork(option.lineOfWork);
  // };

  // const onChangeLineOfWork = (value) => {
  //   if (value === "") {
  //     setLineOfWork("");
  //   }
  // };

  // const onSelectWorkPeriod = (value, option) => {
  //   setDataId(option.dataId);
  // };

  // const onChangeWorkPeriod = (value) => {
  //   if (value === "") {
  //     setDataId("");
  //   }
  // };

  const fetchVisitListYear = useCallback(async () => {
    const res = await getListVisitYear();
    if (res.data.code === SUCCESS_CODE) {
      const { objectValue } = res.data;
      setLisYear(objectValue);
    }
  }, []);

  useEffect(() => {
    fetchVisitListYear();
  }, []);

  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                คลังข้อมูลการเยี่ยมชม
              </Title>
              <div>
                <Space>
                  {(roleUser[0]?.isAll || roleUser[0]?.isCreate) && (
                    <Button
                      type="primary"
                      onClick={() => navigate(routes.add_customer_visit)}
                    >
                      <PlusOutlined /> เพิ่มข้อมูล
                    </Button>
                  )}
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={form}
        style={{
          padding: 20,
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
          boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`,
        }}
        onFinish={(value) =>
          onSearch({
            ...value,
          })
        }
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"yearOfBudget"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="ปีงบประมาณ"
                maxTagCount={"responsive"}
              >
                {listYear.map((item) => (
                  <Option value={item}>{item}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="" name={"lineOfWork"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="สายปฏิบัติการ"
                maxTagCount={"responsive"}
              >
                {lineOfWorkList &&
                  lineOfWorkList.map((l) => (
                    <Option value={l.lineOfWork}>{l.nameTh}</Option>
                  ))}
              </Select>
              {/* <AutoComplete
                filterOption={true}
                options={lineOfWorkList}
                onChange={(e) => onChangeLineOfWork(e)}
                onSelect={onSelectLineOfWork}
              >
                <Input
                  placeholder="สายปฏิบัติการ"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete> */}
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item label="" name={"estateId"}>
              <AutoComplete
                filterOption={true}
                options={estateList}
                onChange={(e) => onChangeEstateId(e)}
                onSelect={onSelectEstateId}
              >
                <Input
                  placeholder="ชื่อนิคมอุตสาหกรรม"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </Form.Item>
          </Col>

          {/* <Col span={8}>
            <Form.Item label="" name={"customerGroupByAge"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="กรุณาเลือก"
              >
                {workPeriod.map((item) => (
                  <Option value={item.dataId}>{item.dataDetailTh}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}

          {/* <Col span={8}>
            <Form.Item label="" name={"customerGroupByAge"}>
              <AutoComplete
                filterOption={true}
                options={workPeriodList}
                onChange={(e) => onChangeWorkPeriod(e)}
                onSelect={onSelectWorkPeriod}
              >
                <Input
                  placeholder="กลุ่มลูกค้าตามอายุ"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </Form.Item>
          </Col> */}

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
